import type { FaireProductEntity } from "../../entity_types/product";

export const p_u3wexefg6j: FaireProductEntity = {
  token: "p_u3wexefg6j",
  type: "product",
  name: "Modern Pastry, Boston - Storefront Art Print - New England",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/1cdfe1c9d199f3ee5fa8e47ad1b392cd9cecf37d92aa3920a0d3a94f40909d34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1f420b39fa6960730214217feb76c7fc8fb507952d36bf8ed59f56fa60a60dc.jpeg",
    "https://cdn.faire.com/fastly/ea38a84f11a96ba6b72b83ab36aedb63027305c91a701513edbbaa54d0c80c45.jpeg",
    "https://cdn.faire.com/fastly/9ea1cf34f62b338e62dcfb885714f193371bac440bf62bb88588b4e55d5a6b5a.jpeg",
    "https://cdn.faire.com/fastly/0f130552a96357f24d110a867784976ead116f08e225cc9129cf768a81673b90.jpeg",
    "https://cdn.faire.com/fastly/2423a4bae0ffd948f93e3ad0ec66d10af0e072c2d49e7497dbe28a1e47a557e7.jpeg",
    "https://cdn.faire.com/fastly/4ec82b89c358ffab786f76b2fed9261e1902f8c81d224a37e537551ecd866693.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of Modern Pastry in Boston, Massachusetts, originally created with gouache and ink.\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:14.402Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
